/* src/app/modules/product-labels/smart-labels/manage-label-smart-filters-modal/manage-label-smart-filters-modal.component.scss */
.manage-label-smart-filters-container {
  padding-inline: 0.2rem;
}
.label-preview-container {
  display: flex;
  justify-content: center;
  background-color: white;
}
.smart-filter-list {
  display: block;
}
.remove-existing-products-switch {
  display: block;
  margin-top: 1rem;
}
.remove-existing-products-switch.disabled {
  opacity: 0.5;
}
:host ::ng-deep .reactive-form-switch-container {
  gap: 1rem;
}
:host ::ng-deep .reactive-form-switch {
  margin: 0 !important;
}
.sticky-footer-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.sticky-footer-container .button-holder {
  display: flex;
  align-self: flex-end;
  gap: 1rem;
  background-color: #ffffff;
}
/*# sourceMappingURL=manage-label-smart-filters-modal.component.css.map */
